import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'are_there_written_recs_of_these_cases'

export const dataPointDefinition = {
  retracedId: 'are_there_written_recs_of_these_cases',
  name: 'Are there written records of these cases?',
  description: '',
  meta: {},
  fieldTypeId: 'YES_NO',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'yes-no',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
      slcpOptionName: 'yes-no',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'hb-3--2',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 10000,
  sectionId: '2.2.7',
  impactArea: 'Forced Labour',
  impactAreaId: 'FORCED_LABOUR',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
